import { createContext, useContext } from "react";

export const PlayerModalContext = createContext(null);

export function usePlayerModal() {
    const ctx = useContext(PlayerModalContext);
    return ctx ?? { openPlayer: () => {} };
}
